/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 *
 * DefaultLayout
 *
 */

import { Header } from '@components/Header';
import { Footer } from '@components/Footer';
import { Card, CardBody, CardFooter, CardHeader } from '@chakra-ui/react';
import { styles } from './styles';

interface DefaultLayoutProps {
	hasHeader?: boolean;
	hasFooter?: boolean;
	headerProps?: any;
	children?: JSX.Element;
}

const DefaultLayout = ({ hasHeader, hasFooter, children }: DefaultLayoutProps) => {
	return (
		<Card sx={styles.container}>
			{hasHeader && (
				<CardHeader sx={styles.header} zIndex={99}>
					<Header />
				</CardHeader>
			)}

			<CardBody sx={styles.body}>{children}</CardBody>

			{hasFooter && (
				<CardFooter sx={styles.footer}>
					<Footer />
				</CardFooter>
			)}
		</Card>
	);
};

export { DefaultLayout };
